/*
 * ==========================================
 * |          GENERATED BY SUPAZOD          |
 * ==========================================
 */

import { z } from "zod";
import { type Json } from "./dbTypes.gen";

export const publicActivityStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicActivityTypeEnumSchema = z.enum([
  "CLASSROOM",
  "YARD",
  "PRACTICAL",
  "OBSERVATION",
  "SIMULATOR",
  "OTHER",
]);

export const publicCampusStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicCertificateStatusEnumSchema = z.enum(["SENT", "FAILED"]);

export const publicContractStatusEnumSchema = z.enum([
  "SENT",
  "SIGNED",
  "NOT_SENT",
]);

export const publicCourseStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicEnrolmentStatusEnumSchema = z.enum([
  "PENDING",
  "ACTIVE",
  "COMPLETED",
  "CANCELLED",
  "UNCOMPLETED",
  "TO_CERTIFY",
]);

export const publicEnrolmentsDocumentsTypesStatusEnumSchema = z.enum([
  "NOT_RECEIVED",
  "RECEIVED",
  "APPROVED",
  "REJECTED",
]);

export const publicEventAttendanceStatusEnumSchema = z.enum([
  "ATTENDED",
  "ABSENT",
  "NOT_RECORDED",
]);

export const publicEventStatusEnumSchema = z.enum([
  "FINISHED",
  "SCHEDULED",
  "CANCELLED",
]);

export const publicInvoiceDeliveryMethodEnumSchema = z.enum([
  "EMAIL",
  "MAIL",
  "OTHER",
  "NONE",
]);

export const publicInvoiceSendStateEnumSchema = z.enum([
  "NOT_READY",
  "READY",
  "SENT",
]);

export const publicInvoiceStatusEnumSchema = z.enum([
  "DRAFT",
  "DUE",
  "PARTIAL",
  "OVERDUE",
  "PAID",
  "CANCELLED",
]);

export const publicLessonRouteLevelEnumSchema = z.enum([
  "BEGINNER",
  "INTERMEDIATE",
  "ADVANCED",
  "EXPRESSWAY",
]);

export const publicLessonRouteStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicLessonStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicLocationStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicLocationTypeEnumSchema = z.enum([
  "OFFICE",
  "YARD",
  "PIT",
  "DRIVE_TEST",
  "VIRTUAL",
  "OTHER",
]);

export const publicModuleStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicPayerGroupEnumSchema = z.enum([
  "STUDENTS",
  "COMPANY",
  "GOVERNMENT",
  "INDIGENOUS_BAND",
  "WORKER_COMPANY",
  "INSURANCE",
  "OTHER",
]);

export const publicPaymentStatusEnumSchema = z.enum([
  "DRAFT",
  "DUE",
  "PARTIAL",
  "OVERDUE",
  "PAID",
  "CANCELLED",
]);

export const publicPaymentTypeEnumSchema = z.enum([
  "CASH",
  "CHECK",
  "EMAIL_MONEY_TRANSFER",
  "CREDIT_CARD",
  "BANK_TRANSFER",
  "OTHER",
]);

export const publicProvinceEnumSchema = z.enum([
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
]);

export const publicRegistrationStatusEnumSchema = z.enum([
  "DOCS_REQUIRED",
  "DOCS_TO_REVIEW",
  "CONTRACT_TO_SEND",
  "STUDENT_TO_SIGN",
  "DOCS_DENIED",
  "SIGNED",
]);

export const publicSkillStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const publicStaffRoleEnumSchema = z.enum([
  "OWNER",
  "CENTRAL_MANAGER",
  "CSR",
  "CAMPUS_MANAGER",
  "INSTRUCTOR",
]);

export const publicStaffStatusEnumSchema = z.enum(["ACTIVE", "DEACTIVATED"]);

export const publicStudentStatusEnumSchema = z.enum([
  "ACTIVE",
  "INVITED",
  "NOT_INVITED",
  "INACTIVE",
]);

export const publicVehicleStatusEnumSchema = z.enum(["ACTIVE", "INACTIVE"]);

export const storageBuckettypeSchema = z.enum([
  "STANDARD",
  "ANALYTICS",
  "VECTOR",
]);

export const jsonSchema: z.ZodSchema<Json> = z.lazy(() =>
  z
    .union([
      z.string(),
      z.number(),
      z.boolean(),
      z.record(z.string(), z.union([jsonSchema, z.undefined()])),
      z.array(jsonSchema),
    ])
    .nullable(),
);

export const rowAchievementsTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  updated_at: z.string(),
});

export const insertAchievementsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string(),
  updated_at: z.string().optional(),
});

export const updateAchievementsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  updated_at: z.string().optional(),
});

export const rowActivitiesTypeSchema = z.object({
  created_at: z.string(),
  duration: z.number(),
  id: z.string(),
  name: z.string(),
  status: publicActivityStatusEnumSchema,
  type: publicActivityTypeEnumSchema,
  updated_at: z.string(),
});

export const insertActivitiesTypeSchema = z.object({
  created_at: z.string().optional(),
  duration: z.number().optional(),
  id: z.string().optional(),
  name: z.string(),
  status: publicActivityStatusEnumSchema.optional(),
  type: publicActivityTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateActivitiesTypeSchema = z.object({
  created_at: z.string().optional(),
  duration: z.number().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  status: publicActivityStatusEnumSchema.optional(),
  type: publicActivityTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowActivitiesSkillsTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  skill_id: z.string(),
  updated_at: z.string(),
});

export const insertActivitiesSkillsTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  skill_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateActivitiesSkillsTypeSchema = z.object({
  activity_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  skill_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsActivitiesSkillsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("activities_skills_activity_id_fkey"),
    columns: z.tuple([z.literal("activity_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("activities"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("activities_skills_skill_id_fkey"),
    columns: z.tuple([z.literal("skill_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("skills"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCalendarEventsMvRefreshStateTypeSchema = z.object({
  id: z.boolean(),
  last_refreshed_at: z.string().nullable(),
  needs_refresh: z.boolean(),
});

export const insertCalendarEventsMvRefreshStateTypeSchema = z.object({
  id: z.boolean().optional(),
  last_refreshed_at: z.string().optional().nullable(),
  needs_refresh: z.boolean().optional(),
});

export const updateCalendarEventsMvRefreshStateTypeSchema = z.object({
  id: z.boolean().optional(),
  last_refreshed_at: z.string().optional().nullable(),
  needs_refresh: z.boolean().optional(),
});

export const rowCampusesTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  province: publicProvinceEnumSchema,
  short_code: z.string(),
  status: publicCampusStatusEnumSchema,
  updated_at: z.string(),
});

export const insertCampusesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string(),
  province: publicProvinceEnumSchema,
  short_code: z.string().optional(),
  status: publicCampusStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateCampusesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  province: publicProvinceEnumSchema.optional(),
  short_code: z.string().optional(),
  status: publicCampusStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowCampusesCoursesTypeSchema = z.object({
  campus_id: z.string(),
  course_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  updated_at: z.string(),
});

export const insertCampusesCoursesTypeSchema = z.object({
  campus_id: z.string(),
  course_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const updateCampusesCoursesTypeSchema = z.object({
  campus_id: z.string().optional(),
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsCampusesCoursesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("campuses_courses_campus_id_fkey"),
    columns: z.tuple([z.literal("campus_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("campuses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("campuses_courses_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCertificatesTypeSchema = z.object({
  created_at: z.string(),
  failed_at: z.string().nullable(),
  id: z.string(),
  sent_at: z.string().nullable(),
  status: publicCertificateStatusEnumSchema,
  updated_at: z.string(),
});

export const insertCertificatesTypeSchema = z.object({
  created_at: z.string().optional(),
  failed_at: z.string().optional().nullable(),
  id: z.string().optional(),
  sent_at: z.string().optional().nullable(),
  status: publicCertificateStatusEnumSchema,
  updated_at: z.string().optional(),
});

export const updateCertificatesTypeSchema = z.object({
  created_at: z.string().optional(),
  failed_at: z.string().optional().nullable(),
  id: z.string().optional(),
  sent_at: z.string().optional().nullable(),
  status: publicCertificateStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowClassroomTypesTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  length_in_days: z.number(),
  name: z.string(),
  updated_at: z.string(),
});

export const insertClassroomTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  length_in_days: z.number(),
  name: z.string(),
  updated_at: z.string().optional(),
});

export const updateClassroomTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  length_in_days: z.number().optional(),
  name: z.string().optional(),
  updated_at: z.string().optional(),
});

export const rowContractsTypeSchema = z.object({
  created_at: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  sent_at: z.string().nullable(),
  signed_at: z.string().nullable(),
  status: publicContractStatusEnumSchema,
  updated_at: z.string(),
  version: z.number(),
});

export const insertContractsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  sent_at: z.string().optional().nullable(),
  signed_at: z.string().optional().nullable(),
  status: publicContractStatusEnumSchema,
  updated_at: z.string().optional(),
  version: z.number(),
});

export const updateContractsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  sent_at: z.string().optional().nullable(),
  signed_at: z.string().optional().nullable(),
  status: publicContractStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
  version: z.number().optional(),
});

export const relationshipsContractsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("contracts_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCoursesTypeSchema = z.object({
  created_at: z.string(),
  description: z.string().nullable(),
  full_text_search: z.unknown(),
  id: z.string(),
  is_registered_with_province: z.boolean(),
  length_in_days: z.number().nullable(),
  name: z.string(),
  observation_sessions_count: z.number(),
  status: publicCourseStatusEnumSchema,
  updated_at: z.string(),
});

export const insertCoursesTypeSchema = z.object({
  created_at: z.string().optional(),
  description: z.string().optional().nullable(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  is_registered_with_province: z.boolean(),
  length_in_days: z.number().optional().nullable(),
  name: z.string(),
  observation_sessions_count: z.number().optional(),
  status: publicCourseStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateCoursesTypeSchema = z.object({
  created_at: z.string().optional(),
  description: z.string().optional().nullable(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  is_registered_with_province: z.boolean().optional(),
  length_in_days: z.number().optional().nullable(),
  name: z.string().optional(),
  observation_sessions_count: z.number().optional(),
  status: publicCourseStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowCoursesAchievementsTypeSchema = z.object({
  achievement_id: z.string(),
  course_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  updated_at: z.string(),
  weight: z.number(),
});

export const insertCoursesAchievementsTypeSchema = z.object({
  achievement_id: z.string(),
  course_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
  weight: z.number(),
});

export const updateCoursesAchievementsTypeSchema = z.object({
  achievement_id: z.string().optional(),
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
  weight: z.number().optional(),
});

export const relationshipsCoursesAchievementsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("courses_achievements_achievement_id_fkey"),
    columns: z.tuple([z.literal("achievement_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("achievements"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("courses_achievements_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCoursesClassroomsTypesTypeSchema = z.object({
  classroom_type_id: z.string(),
  course_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  updated_at: z.string(),
});

export const insertCoursesClassroomsTypesTypeSchema = z.object({
  classroom_type_id: z.string(),
  course_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const updateCoursesClassroomsTypesTypeSchema = z.object({
  classroom_type_id: z.string().optional(),
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsCoursesClassroomsTypesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal(
      "courses_classrooms_types_classroom_type_id_fkey",
    ),
    columns: z.tuple([z.literal("classroom_type_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("classroom_types"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("courses_classrooms_types_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCoursesDocumentsTypesTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string(),
  document_type_id: z.string(),
  id: z.string(),
  updated_at: z.string(),
});

export const insertCoursesDocumentsTypesTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string().optional(),
  document_type_id: z.string(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const updateCoursesDocumentsTypesTypeSchema = z.object({
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  document_type_id: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsCoursesDocumentsTypesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("courses_documents_types_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("courses_documents_types_document_type_id_fkey"),
    columns: z.tuple([z.literal("document_type_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("document_types"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCoursesLessonsTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  lesson_id: z.string(),
  updated_at: z.string(),
});

export const insertCoursesLessonsTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  lesson_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateCoursesLessonsTypeSchema = z.object({
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  lesson_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsCoursesLessonsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("courses_lessons_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("courses_lessons_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCoursesProductsTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string(),
  has_fixed_price: z.boolean(),
  id: z.string(),
  price: z.number(),
  product_id: z.string(),
  updated_at: z.string(),
});

export const insertCoursesProductsTypeSchema = z.object({
  course_id: z.string(),
  created_at: z.string().optional(),
  has_fixed_price: z.boolean(),
  id: z.string().optional(),
  price: z.number(),
  product_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateCoursesProductsTypeSchema = z.object({
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  has_fixed_price: z.boolean().optional(),
  id: z.string().optional(),
  price: z.number().optional(),
  product_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsCoursesProductsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("courses_products_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("courses_products_product_id_fkey"),
    columns: z.tuple([z.literal("product_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("products"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowDocumentTypesTypeSchema = z.object({
  created_at: z.string(),
  full_text_search: z.unknown(),
  id: z.string(),
  name: z.string(),
  updated_at: z.string(),
});

export const insertDocumentTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  name: z.string(),
  updated_at: z.string().optional(),
});

export const updateDocumentTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  updated_at: z.string().optional(),
});

export const rowEnrolmentGeneralDocumentsTypeSchema = z.object({
  created_at: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  name: z.string(),
  storage_keys: z.array(z.string()).nullable(),
  updated_at: z.string(),
});

export const insertEnrolmentGeneralDocumentsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  name: z.string(),
  storage_keys: z.array(z.string()).optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentGeneralDocumentsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  storage_keys: z.array(z.string()).optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentGeneralDocumentsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolment_general_documents_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsTypeSchema = z.object({
  advanced_standing_details: z.string().nullable(),
  campus_id: z.string(),
  certificate_id: z.string().nullable(),
  city: z.string().nullable(),
  completed_lessons: z.array(z.string()),
  completed_lessons_count: z.number().nullable(),
  course_id: z.string(),
  created_at: z.string(),
  diploma_date: z.string().nullable(),
  driver_licence_class: z.string().nullable(),
  driver_licence_expiry: z.string().nullable(),
  driver_licence_number: z.string().nullable(),
  end_date: z.string(),
  has_advanced_standing: z.boolean(),
  id: z.string(),
  melt_uploaded_at: z.string().nullable(),
  next_of_kin_name: z.string().nullable(),
  next_of_kin_phone_number: z.string().nullable(),
  postal_code: z.string().nullable(),
  province: publicProvinceEnumSchema.nullable(),
  registration_status: publicRegistrationStatusEnumSchema,
  reschedule_lessons: z.array(z.string()),
  scheduled_lessons: z.array(z.string()),
  scheduled_lessons_count: z.number().nullable(),
  start_date: z.string(),
  status: publicEnrolmentStatusEnumSchema,
  street_address: z.string().nullable(),
  student_id: z.string(),
  transcript_id: z.string().nullable(),
  unscheduled_lessons: z.array(z.string()),
  unscheduled_lessons_count: z.number().nullable(),
  unsigned_lessons: z.array(z.string()),
  unsigned_lessons_count: z.number().nullable(),
  updated_at: z.string(),
});

export const insertEnrolmentsTypeSchema = z.object({
  advanced_standing_details: z.string().optional().nullable(),
  campus_id: z.string(),
  certificate_id: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  completed_lessons: z.array(z.string()).optional(),
  completed_lessons_count: z.number().optional().nullable(),
  course_id: z.string(),
  created_at: z.string().optional(),
  diploma_date: z.string().optional().nullable(),
  driver_licence_class: z.string().optional().nullable(),
  driver_licence_expiry: z.string().optional().nullable(),
  driver_licence_number: z.string().optional().nullable(),
  end_date: z.string(),
  has_advanced_standing: z.boolean(),
  id: z.string().optional(),
  melt_uploaded_at: z.string().optional().nullable(),
  next_of_kin_name: z.string().optional().nullable(),
  next_of_kin_phone_number: z.string().optional().nullable(),
  postal_code: z.string().optional().nullable(),
  province: publicProvinceEnumSchema.optional().nullable(),
  registration_status: publicRegistrationStatusEnumSchema.optional(),
  reschedule_lessons: z.array(z.string()).optional(),
  scheduled_lessons: z.array(z.string()).optional(),
  scheduled_lessons_count: z.number().optional().nullable(),
  start_date: z.string(),
  status: publicEnrolmentStatusEnumSchema.optional(),
  street_address: z.string().optional().nullable(),
  student_id: z.string(),
  transcript_id: z.string().optional().nullable(),
  unscheduled_lessons: z.array(z.string()).optional(),
  unscheduled_lessons_count: z.number().optional().nullable(),
  unsigned_lessons: z.array(z.string()).optional(),
  unsigned_lessons_count: z.number().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsTypeSchema = z.object({
  advanced_standing_details: z.string().optional().nullable(),
  campus_id: z.string().optional(),
  certificate_id: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  completed_lessons: z.array(z.string()).optional(),
  completed_lessons_count: z.number().optional().nullable(),
  course_id: z.string().optional(),
  created_at: z.string().optional(),
  diploma_date: z.string().optional().nullable(),
  driver_licence_class: z.string().optional().nullable(),
  driver_licence_expiry: z.string().optional().nullable(),
  driver_licence_number: z.string().optional().nullable(),
  end_date: z.string().optional(),
  has_advanced_standing: z.boolean().optional(),
  id: z.string().optional(),
  melt_uploaded_at: z.string().optional().nullable(),
  next_of_kin_name: z.string().optional().nullable(),
  next_of_kin_phone_number: z.string().optional().nullable(),
  postal_code: z.string().optional().nullable(),
  province: publicProvinceEnumSchema.optional().nullable(),
  registration_status: publicRegistrationStatusEnumSchema.optional(),
  reschedule_lessons: z.array(z.string()).optional(),
  scheduled_lessons: z.array(z.string()).optional(),
  scheduled_lessons_count: z.number().optional().nullable(),
  start_date: z.string().optional(),
  status: publicEnrolmentStatusEnumSchema.optional(),
  street_address: z.string().optional().nullable(),
  student_id: z.string().optional(),
  transcript_id: z.string().optional().nullable(),
  unscheduled_lessons: z.array(z.string()).optional(),
  unscheduled_lessons_count: z.number().optional().nullable(),
  unsigned_lessons: z.array(z.string()).optional(),
  unsigned_lessons_count: z.number().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_campus_id_fkey"),
    columns: z.tuple([z.literal("campus_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("campuses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_certificate_id_fkey"),
    columns: z.tuple([z.literal("certificate_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("certificates"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_course_id_fkey"),
    columns: z.tuple([z.literal("course_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("courses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_student_id_fkey"),
    columns: z.tuple([z.literal("student_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("students"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_transcript_id_fkey"),
    columns: z.tuple([z.literal("transcript_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("transcripts"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsAchievementsTypeSchema = z.object({
  achievement_id: z.string(),
  created_at: z.string(),
  enrolment_id: z.string(),
  grade: z.number(),
  id: z.string(),
  updated_at: z.string(),
});

export const insertEnrolmentsAchievementsTypeSchema = z.object({
  achievement_id: z.string(),
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  grade: z.number().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsAchievementsTypeSchema = z.object({
  achievement_id: z.string().optional(),
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  grade: z.number().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsAchievementsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_achievements_achievement_id_fkey"),
    columns: z.tuple([z.literal("achievement_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("achievements"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_achievements_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsClassroomsTypeSchema = z.object({
  classroom_type_id: z.string(),
  created_at: z.string(),
  end_date: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  start_date: z.string(),
  updated_at: z.string(),
});

export const insertEnrolmentsClassroomsTypeSchema = z.object({
  classroom_type_id: z.string(),
  created_at: z.string().optional(),
  end_date: z.string(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  start_date: z.string(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsClassroomsTypeSchema = z.object({
  classroom_type_id: z.string().optional(),
  created_at: z.string().optional(),
  end_date: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  start_date: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsClassroomsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_classrooms_classroom_type_id_fkey"),
    columns: z.tuple([z.literal("classroom_type_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("classroom_types"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_classrooms_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsDocumentsTypesTypeSchema = z.object({
  approved_at: z.string().nullable(),
  created_at: z.string(),
  document_type_id: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  rejected_at: z.string().nullable(),
  rejection_reason: z.string().nullable(),
  status: publicEnrolmentsDocumentsTypesStatusEnumSchema,
  storage_keys: z.array(z.string()).nullable(),
  updated_at: z.string(),
  uploaded_at: z.string().nullable(),
});

export const insertEnrolmentsDocumentsTypesTypeSchema = z.object({
  approved_at: z.string().optional().nullable(),
  created_at: z.string().optional(),
  document_type_id: z.string(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  rejected_at: z.string().optional().nullable(),
  rejection_reason: z.string().optional().nullable(),
  status: publicEnrolmentsDocumentsTypesStatusEnumSchema.optional(),
  storage_keys: z.array(z.string()).optional().nullable(),
  updated_at: z.string().optional(),
  uploaded_at: z.string().optional().nullable(),
});

export const updateEnrolmentsDocumentsTypesTypeSchema = z.object({
  approved_at: z.string().optional().nullable(),
  created_at: z.string().optional(),
  document_type_id: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  rejected_at: z.string().optional().nullable(),
  rejection_reason: z.string().optional().nullable(),
  status: publicEnrolmentsDocumentsTypesStatusEnumSchema.optional(),
  storage_keys: z.array(z.string()).optional().nullable(),
  updated_at: z.string().optional(),
  uploaded_at: z.string().optional().nullable(),
});

export const relationshipsEnrolmentsDocumentsTypesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal(
      "enrolments_documents_types_document_type_id_fkey",
    ),
    columns: z.tuple([z.literal("document_type_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("document_types"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_documents_types_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsEventsTypeSchema = z.object({
  attendance_status: publicEventAttendanceStatusEnumSchema,
  created_at: z.string(),
  enrolment_id: z.string(),
  event_id: z.string(),
  id: z.string(),
  is_optional_attendance: z.boolean(),
  student_sign_at: z.string().nullable(),
  student_signature: z.string().nullable(),
  updated_at: z.string(),
});

export const insertEnrolmentsEventsTypeSchema = z.object({
  attendance_status: publicEventAttendanceStatusEnumSchema.optional(),
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  event_id: z.string(),
  id: z.string().optional(),
  is_optional_attendance: z.boolean().optional(),
  student_sign_at: z.string().optional().nullable(),
  student_signature: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsEventsTypeSchema = z.object({
  attendance_status: publicEventAttendanceStatusEnumSchema.optional(),
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  event_id: z.string().optional(),
  id: z.string().optional(),
  is_optional_attendance: z.boolean().optional(),
  student_sign_at: z.string().optional().nullable(),
  student_signature: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsEventsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_events_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_mv"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_raw"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsNotesTypeSchema = z.object({
  content: z.string(),
  created_at: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  staff_id: z.string().nullable(),
  updated_at: z.string(),
});

export const insertEnrolmentsNotesTypeSchema = z.object({
  content: z.string(),
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  staff_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsNotesTypeSchema = z.object({
  content: z.string().optional(),
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  staff_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsNotesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_notes_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_notes_staff_id_fkey"),
    columns: z.tuple([z.literal("staff_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("staff"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEnrolmentsProductsTypeSchema = z.object({
  created_at: z.string(),
  enrolment_id: z.string(),
  has_fixed_price: z.boolean(),
  id: z.string(),
  price: z.number(),
  product_id: z.string().nullable(),
  product_name: z.string().nullable(),
  updated_at: z.string(),
});

export const insertEnrolmentsProductsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  has_fixed_price: z.boolean().optional(),
  id: z.string().optional(),
  price: z.number(),
  product_id: z.string().optional().nullable(),
  product_name: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEnrolmentsProductsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  has_fixed_price: z.boolean().optional(),
  id: z.string().optional(),
  price: z.number().optional(),
  product_id: z.string().optional().nullable(),
  product_name: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEnrolmentsProductsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("enrolments_products_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("enrolments_products_product_id_fkey"),
    columns: z.tuple([z.literal("product_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("products"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEvaluationsTypeSchema = z.object({
  created_at: z.string(),
  enrolment_id: z.string(),
  event_id: z.string(),
  id: z.string(),
  total_grade: z.number(),
  updated_at: z.string(),
});

export const insertEvaluationsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string(),
  event_id: z.string(),
  id: z.string().optional(),
  total_grade: z.number().optional(),
  updated_at: z.string().optional(),
});

export const updateEvaluationsTypeSchema = z.object({
  created_at: z.string().optional(),
  enrolment_id: z.string().optional(),
  event_id: z.string().optional(),
  id: z.string().optional(),
  total_grade: z.number().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsEvaluationsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("evaluations_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("evaluations_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("evaluations_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_mv"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("evaluations_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_raw"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("evaluations_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEventsTypeSchema = z.object({
  created_at: z.string(),
  event_notes: z.string().nullable(),
  id: z.string(),
  is_partial: z.boolean(),
  is_published: z.boolean(),
  lesson_id: z.string(),
  lesson_route_id: z.string().nullable(),
  location_id: z.string(),
  odometer_end: z.number().nullable(),
  odometer_start: z.number().nullable(),
  scheduled_at: z.string(),
  signed_by_staff_id: z.string().nullable(),
  staff_notes: z.string().nullable(),
  staff_sign_at: z.string().nullable(),
  staff_signature: z.string().nullable(),
  status: publicEventStatusEnumSchema,
  student_notes: z.string().nullable(),
  updated_at: z.string(),
});

export const insertEventsTypeSchema = z.object({
  created_at: z.string().optional(),
  event_notes: z.string().optional().nullable(),
  id: z.string().optional(),
  is_partial: z.boolean().optional(),
  is_published: z.boolean().optional(),
  lesson_id: z.string(),
  lesson_route_id: z.string().optional().nullable(),
  location_id: z.string(),
  odometer_end: z.number().optional().nullable(),
  odometer_start: z.number().optional().nullable(),
  scheduled_at: z.string(),
  signed_by_staff_id: z.string().optional().nullable(),
  staff_notes: z.string().optional().nullable(),
  staff_sign_at: z.string().optional().nullable(),
  staff_signature: z.string().optional().nullable(),
  status: publicEventStatusEnumSchema.optional(),
  student_notes: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateEventsTypeSchema = z.object({
  created_at: z.string().optional(),
  event_notes: z.string().optional().nullable(),
  id: z.string().optional(),
  is_partial: z.boolean().optional(),
  is_published: z.boolean().optional(),
  lesson_id: z.string().optional(),
  lesson_route_id: z.string().optional().nullable(),
  location_id: z.string().optional(),
  odometer_end: z.number().optional().nullable(),
  odometer_start: z.number().optional().nullable(),
  scheduled_at: z.string().optional(),
  signed_by_staff_id: z.string().optional().nullable(),
  staff_notes: z.string().optional().nullable(),
  staff_sign_at: z.string().optional().nullable(),
  staff_signature: z.string().optional().nullable(),
  status: publicEventStatusEnumSchema.optional(),
  student_notes: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsEventsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_lesson_route_id_fkey"),
    columns: z.tuple([z.literal("lesson_route_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lesson_routes"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_location_id_fkey"),
    columns: z.tuple([z.literal("location_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("locations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_signed_by_staff_id_fkey"),
    columns: z.tuple([z.literal("signed_by_staff_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("staff"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEventsActivitiesTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string(),
  duration: z.number(),
  event_id: z.string(),
  id: z.string(),
  updated_at: z.string(),
});

export const insertEventsActivitiesTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string().optional(),
  duration: z.number(),
  event_id: z.string(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const updateEventsActivitiesTypeSchema = z.object({
  activity_id: z.string().optional(),
  created_at: z.string().optional(),
  duration: z.number().optional(),
  event_id: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsEventsActivitiesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_activities_activity_id_fkey"),
    columns: z.tuple([z.literal("activity_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("activities"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_activities_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_activities_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_mv"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_activities_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_raw"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_activities_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowEventsVehiclesTypeSchema = z.object({
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  updated_at: z.string(),
  vehicle_id: z.string(),
});

export const insertEventsVehiclesTypeSchema = z.object({
  created_at: z.string().optional(),
  event_id: z.string(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
  vehicle_id: z.string(),
});

export const updateEventsVehiclesTypeSchema = z.object({
  created_at: z.string().optional(),
  event_id: z.string().optional(),
  id: z.string().optional(),
  updated_at: z.string().optional(),
  vehicle_id: z.string().optional(),
});

export const relationshipsEventsVehiclesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_vehicles_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_vehicles_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_mv"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_vehicles_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_raw"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_vehicles_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_vehicles_vehicle_id_fkey"),
    columns: z.tuple([z.literal("vehicle_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("vehicles"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowInvoiceItemsTypeSchema = z.object({
  amount: z.number(),
  created_at: z.string(),
  enrolment_product_id: z.string(),
  id: z.string(),
  invoice_id: z.string(),
  updated_at: z.string(),
});

export const insertInvoiceItemsTypeSchema = z.object({
  amount: z.number(),
  created_at: z.string().optional(),
  enrolment_product_id: z.string(),
  id: z.string().optional(),
  invoice_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateInvoiceItemsTypeSchema = z.object({
  amount: z.number().optional(),
  created_at: z.string().optional(),
  enrolment_product_id: z.string().optional(),
  id: z.string().optional(),
  invoice_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsInvoiceItemsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("invoice_items_enrolment_product_id_fkey"),
    columns: z.tuple([z.literal("enrolment_product_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments_products"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("invoice_items_invoice_id_fkey"),
    columns: z.tuple([z.literal("invoice_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("invoices"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowInvoicePaymentScheduleTypeSchema = z.object({
  created_at: z.string(),
  due_date: z.string(),
  id: z.string(),
  invoice_id: z.string(),
  notes: z.string().nullable(),
  total: z.number(),
  updated_at: z.string(),
});

export const insertInvoicePaymentScheduleTypeSchema = z.object({
  created_at: z.string().optional(),
  due_date: z.string(),
  id: z.string().optional(),
  invoice_id: z.string(),
  notes: z.string().optional().nullable(),
  total: z.number(),
  updated_at: z.string().optional(),
});

export const updateInvoicePaymentScheduleTypeSchema = z.object({
  created_at: z.string().optional(),
  due_date: z.string().optional(),
  id: z.string().optional(),
  invoice_id: z.string().optional(),
  notes: z.string().optional().nullable(),
  total: z.number().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsInvoicePaymentScheduleTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("invoice_payment_schedule_invoice_id_fkey"),
    columns: z.tuple([z.literal("invoice_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("invoices"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowInvoicesTypeSchema = z.object({
  created_at: z.string(),
  due_date: z.string(),
  enrolment_id: z.string(),
  id: z.string(),
  invoice_date: z.string(),
  invoice_number: z.number(),
  is_placeholder: z.boolean(),
  payer_id: z.string(),
  send_state: publicInvoiceSendStateEnumSchema,
  status: publicInvoiceStatusEnumSchema,
  total: z.number(),
  updated_at: z.string(),
});

export const insertInvoicesTypeSchema = z.object({
  created_at: z.string().optional(),
  due_date: z.string(),
  enrolment_id: z.string(),
  id: z.string().optional(),
  invoice_date: z.string(),
  invoice_number: z.number().optional(),
  is_placeholder: z.boolean().optional(),
  payer_id: z.string(),
  send_state: publicInvoiceSendStateEnumSchema.optional(),
  status: publicInvoiceStatusEnumSchema.optional(),
  total: z.number(),
  updated_at: z.string().optional(),
});

export const updateInvoicesTypeSchema = z.object({
  created_at: z.string().optional(),
  due_date: z.string().optional(),
  enrolment_id: z.string().optional(),
  id: z.string().optional(),
  invoice_date: z.string().optional(),
  invoice_number: z.number().optional(),
  is_placeholder: z.boolean().optional(),
  payer_id: z.string().optional(),
  send_state: publicInvoiceSendStateEnumSchema.optional(),
  status: publicInvoiceStatusEnumSchema.optional(),
  total: z.number().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsInvoicesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("invoices_enrolment_id_fkey"),
    columns: z.tuple([z.literal("enrolment_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("enrolments"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("invoices_payer_id_fkey"),
    columns: z.tuple([z.literal("payer_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("payers"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowLessonRoutesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  level: publicLessonRouteLevelEnumSchema,
  name: z.string(),
  status: publicLessonRouteStatusEnumSchema,
  updated_at: z.string(),
});

export const insertLessonRoutesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  level: publicLessonRouteLevelEnumSchema,
  name: z.string(),
  status: publicLessonRouteStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateLessonRoutesTypeSchema = z.object({
  campus_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  level: publicLessonRouteLevelEnumSchema.optional(),
  name: z.string().optional(),
  status: publicLessonRouteStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const relationshipsLessonRoutesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("lesson_routes_campus_id_fkey"),
    columns: z.tuple([z.literal("campus_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("campuses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowLessonsTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  is_attendance_required: z.boolean(),
  is_route_required: z.boolean(),
  is_vehicle_required: z.boolean(),
  module_id: z.string(),
  name: z.string(),
  status: publicLessonStatusEnumSchema,
  updated_at: z.string(),
});

export const insertLessonsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  is_attendance_required: z.boolean().optional(),
  is_route_required: z.boolean().optional(),
  is_vehicle_required: z.boolean().optional(),
  module_id: z.string(),
  name: z.string(),
  status: publicLessonStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateLessonsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  is_attendance_required: z.boolean().optional(),
  is_route_required: z.boolean().optional(),
  is_vehicle_required: z.boolean().optional(),
  module_id: z.string().optional(),
  name: z.string().optional(),
  status: publicLessonStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const relationshipsLessonsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("lessons_module_id_fkey"),
    columns: z.tuple([z.literal("module_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("modules"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowLessonsActivitiesTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string(),
  duration: z.number(),
  id: z.string(),
  lesson_id: z.string(),
  updated_at: z.string(),
});

export const insertLessonsActivitiesTypeSchema = z.object({
  activity_id: z.string(),
  created_at: z.string().optional(),
  duration: z.number().optional(),
  id: z.string().optional(),
  lesson_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateLessonsActivitiesTypeSchema = z.object({
  activity_id: z.string().optional(),
  created_at: z.string().optional(),
  duration: z.number().optional(),
  id: z.string().optional(),
  lesson_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsLessonsActivitiesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("lessons_activities_activity_id_fkey"),
    columns: z.tuple([z.literal("activity_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("activities"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("lessons_activities_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowLocationsTypeSchema = z.object({
  address: z.string(),
  created_at: z.string(),
  full_text_search: z.unknown(),
  geo_point: z.unknown(),
  id: z.string(),
  lat: z.number().nullable(),
  lon: z.number().nullable(),
  name: z.string(),
  place_id: z.string().nullable(),
  province: publicProvinceEnumSchema.nullable(),
  status: publicLocationStatusEnumSchema,
  type: publicLocationTypeEnumSchema,
  updated_at: z.string(),
  url: z.string().nullable(),
});

export const insertLocationsTypeSchema = z.object({
  address: z.string().optional(),
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  geo_point: z.unknown().optional(),
  id: z.string().optional(),
  lat: z.number().optional().nullable(),
  lon: z.number().optional().nullable(),
  name: z.string(),
  place_id: z.string().optional().nullable(),
  province: publicProvinceEnumSchema.optional().nullable(),
  status: publicLocationStatusEnumSchema.optional(),
  type: publicLocationTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
  url: z.string().optional().nullable(),
});

export const updateLocationsTypeSchema = z.object({
  address: z.string().optional(),
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  geo_point: z.unknown().optional(),
  id: z.string().optional(),
  lat: z.number().optional().nullable(),
  lon: z.number().optional().nullable(),
  name: z.string().optional(),
  place_id: z.string().optional().nullable(),
  province: publicProvinceEnumSchema.optional().nullable(),
  status: publicLocationStatusEnumSchema.optional(),
  type: publicLocationTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
  url: z.string().optional().nullable(),
});

export const rowLocationsCampusesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  location_id: z.string(),
  updated_at: z.string(),
});

export const insertLocationsCampusesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  location_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateLocationsCampusesTypeSchema = z.object({
  campus_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  location_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsLocationsCampusesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("locations_campuses_campus_id_fkey"),
    columns: z.tuple([z.literal("campus_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("campuses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("locations_campuses_location_id_fkey"),
    columns: z.tuple([z.literal("location_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("locations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowModulesTypeSchema = z.object({
  color: z.string(),
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  status: publicModuleStatusEnumSchema,
  updated_at: z.string(),
});

export const insertModulesTypeSchema = z.object({
  color: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string(),
  status: publicModuleStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateModulesTypeSchema = z.object({
  color: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  status: publicModuleStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowPayersTypeSchema = z.object({
  billing_address: z.string(),
  created_at: z.string(),
  email: z.string(),
  full_text_search: z.unknown(),
  group_type: publicPayerGroupEnumSchema,
  id: z.string(),
  invoice_attention_to: z.string(),
  invoice_delivery_emails: z.array(z.string()),
  invoice_delivery_method: publicInvoiceDeliveryMethodEnumSchema,
  name: z.string(),
  phone_number: z.string(),
  student_id: z.string().nullable(),
  updated_at: z.string(),
});

export const insertPayersTypeSchema = z.object({
  billing_address: z.string(),
  created_at: z.string().optional(),
  email: z.string(),
  full_text_search: z.unknown().optional(),
  group_type: publicPayerGroupEnumSchema,
  id: z.string().optional(),
  invoice_attention_to: z.string(),
  invoice_delivery_emails: z.array(z.string()),
  invoice_delivery_method: publicInvoiceDeliveryMethodEnumSchema,
  name: z.string(),
  phone_number: z.string(),
  student_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updatePayersTypeSchema = z.object({
  billing_address: z.string().optional(),
  created_at: z.string().optional(),
  email: z.string().optional(),
  full_text_search: z.unknown().optional(),
  group_type: publicPayerGroupEnumSchema.optional(),
  id: z.string().optional(),
  invoice_attention_to: z.string().optional(),
  invoice_delivery_emails: z.array(z.string()).optional(),
  invoice_delivery_method: publicInvoiceDeliveryMethodEnumSchema.optional(),
  name: z.string().optional(),
  phone_number: z.string().optional(),
  student_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const relationshipsPayersTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("payers_student_id_fkey"),
    columns: z.tuple([z.literal("student_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("students"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowPaymentsTypeSchema = z.object({
  amount: z.number(),
  created_at: z.string(),
  date_paid: z.string().nullable(),
  due_date: z.string(),
  id: z.string(),
  invoice_id: z.string(),
  note: z.string().nullable(),
  payer_id: z.string(),
  payment_number: z.number(),
  status: publicPaymentStatusEnumSchema,
  type: publicPaymentTypeEnumSchema,
  updated_at: z.string(),
});

export const insertPaymentsTypeSchema = z.object({
  amount: z.number(),
  created_at: z.string().optional(),
  date_paid: z.string().optional().nullable(),
  due_date: z.string(),
  id: z.string().optional(),
  invoice_id: z.string(),
  note: z.string().optional().nullable(),
  payer_id: z.string(),
  payment_number: z.number().optional(),
  status: publicPaymentStatusEnumSchema.optional(),
  type: publicPaymentTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updatePaymentsTypeSchema = z.object({
  amount: z.number().optional(),
  created_at: z.string().optional(),
  date_paid: z.string().optional().nullable(),
  due_date: z.string().optional(),
  id: z.string().optional(),
  invoice_id: z.string().optional(),
  note: z.string().optional().nullable(),
  payer_id: z.string().optional(),
  payment_number: z.number().optional(),
  status: publicPaymentStatusEnumSchema.optional(),
  type: publicPaymentTypeEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const relationshipsPaymentsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("payments_invoice_id_fkey"),
    columns: z.tuple([z.literal("invoice_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("invoices"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("payments_payer_id_fkey"),
    columns: z.tuple([z.literal("payer_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("payers"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowProductsTypeSchema = z.object({
  created_at: z.string(),
  full_text_search: z.unknown(),
  id: z.string(),
  name: z.string(),
  updated_at: z.string(),
});

export const insertProductsTypeSchema = z.object({
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  name: z.string(),
  updated_at: z.string().optional(),
});

export const updateProductsTypeSchema = z.object({
  created_at: z.string().optional(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  updated_at: z.string().optional(),
});

export const rowSkillsTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  skill_set: z.array(z.string()).nullable(),
  status: publicSkillStatusEnumSchema,
  updated_at: z.string(),
});

export const insertSkillsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string(),
  skill_set: z.array(z.string()).optional().nullable(),
  status: publicSkillStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateSkillsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  skill_set: z.array(z.string()).optional().nullable(),
  status: publicSkillStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowSkillsEvaluationsTypeSchema = z.object({
  created_at: z.string(),
  evaluation_id: z.string(),
  grade: z.number().nullable(),
  id: z.string(),
  skill_id: z.string(),
  student_id: z.string(),
  updated_at: z.string(),
});

export const insertSkillsEvaluationsTypeSchema = z.object({
  created_at: z.string().optional(),
  evaluation_id: z.string(),
  grade: z.number().optional().nullable(),
  id: z.string().optional(),
  skill_id: z.string(),
  student_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateSkillsEvaluationsTypeSchema = z.object({
  created_at: z.string().optional(),
  evaluation_id: z.string().optional(),
  grade: z.number().optional().nullable(),
  id: z.string().optional(),
  skill_id: z.string().optional(),
  student_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsSkillsEvaluationsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("skills_evaluations_evaluation_id_fkey"),
    columns: z.tuple([z.literal("evaluation_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("evaluations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("skills_evaluations_skill_id_fkey"),
    columns: z.tuple([z.literal("skill_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("skills"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("skills_evaluations_student_id_fkey"),
    columns: z.tuple([z.literal("student_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("students"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowStaffTypeSchema = z.object({
  created_at: z.string(),
  email: z.string(),
  first_name: z.string(),
  full_text_search: z.unknown(),
  id: z.string(),
  last_name: z.string(),
  role: publicStaffRoleEnumSchema,
  status: publicStaffStatusEnumSchema,
  updated_at: z.string(),
});

export const insertStaffTypeSchema = z.object({
  created_at: z.string().optional(),
  email: z.string(),
  first_name: z.string(),
  full_text_search: z.unknown().optional(),
  id: z.string(),
  last_name: z.string(),
  role: publicStaffRoleEnumSchema,
  status: publicStaffStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const updateStaffTypeSchema = z.object({
  created_at: z.string().optional(),
  email: z.string().optional(),
  first_name: z.string().optional(),
  full_text_search: z.unknown().optional(),
  id: z.string().optional(),
  last_name: z.string().optional(),
  role: publicStaffRoleEnumSchema.optional(),
  status: publicStaffStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
});

export const rowStaffCampusesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  staff_id: z.string(),
  updated_at: z.string(),
});

export const insertStaffCampusesTypeSchema = z.object({
  campus_id: z.string(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  staff_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateStaffCampusesTypeSchema = z.object({
  campus_id: z.string().optional(),
  created_at: z.string().optional(),
  id: z.string().optional(),
  staff_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsStaffCampusesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("staff_campuses_campus_id_fkey"),
    columns: z.tuple([z.literal("campus_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("campuses"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("staff_campuses_staff_id_fkey"),
    columns: z.tuple([z.literal("staff_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("staff"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowStaffEventsTypeSchema = z.object({
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  staff_id: z.string(),
  updated_at: z.string(),
});

export const insertStaffEventsTypeSchema = z.object({
  created_at: z.string().optional(),
  event_id: z.string(),
  id: z.string().optional(),
  staff_id: z.string(),
  updated_at: z.string().optional(),
});

export const updateStaffEventsTypeSchema = z.object({
  created_at: z.string().optional(),
  event_id: z.string().optional(),
  id: z.string().optional(),
  staff_id: z.string().optional(),
  updated_at: z.string().optional(),
});

export const relationshipsStaffEventsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("staff_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("staff_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_mv"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("staff_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("calendar_events_raw"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("staff_events_event_id_fkey"),
    columns: z.tuple([z.literal("event_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("events"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("staff_events_staff_id_fkey"),
    columns: z.tuple([z.literal("staff_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("staff"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowStudentsTypeSchema = z.object({
  created_at: z.string(),
  date_of_birth: z.string().nullable(),
  email: z.string(),
  encrypted_sin: z.string().nullable(),
  first_name: z.string(),
  id: z.string(),
  last_name: z.string(),
  middle_name: z.string().nullable(),
  phone_number: z.string(),
  sin_number: z.string().nullable(),
  status: publicStudentStatusEnumSchema,
  student_number: z.string(),
  updated_at: z.string(),
  wrapped_dek: z.string().nullable(),
});

export const insertStudentsTypeSchema = z.object({
  created_at: z.string().optional(),
  date_of_birth: z.string().optional().nullable(),
  email: z.string(),
  encrypted_sin: z.string().optional().nullable(),
  first_name: z.string(),
  id: z.string(),
  last_name: z.string(),
  middle_name: z.string().optional().nullable(),
  phone_number: z.string(),
  sin_number: z.string().optional().nullable(),
  status: publicStudentStatusEnumSchema.optional(),
  student_number: z.string(),
  updated_at: z.string().optional(),
  wrapped_dek: z.string().optional().nullable(),
});

export const updateStudentsTypeSchema = z.object({
  created_at: z.string().optional(),
  date_of_birth: z.string().optional().nullable(),
  email: z.string().optional(),
  encrypted_sin: z.string().optional().nullable(),
  first_name: z.string().optional(),
  id: z.string().optional(),
  last_name: z.string().optional(),
  middle_name: z.string().optional().nullable(),
  phone_number: z.string().optional(),
  sin_number: z.string().optional().nullable(),
  status: publicStudentStatusEnumSchema.optional(),
  student_number: z.string().optional(),
  updated_at: z.string().optional(),
  wrapped_dek: z.string().optional().nullable(),
});

export const rowTranscriptsTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  sent: z.boolean(),
  sent_at: z.string().nullable(),
  updated_at: z.string(),
});

export const insertTranscriptsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  sent: z.boolean().optional(),
  sent_at: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const updateTranscriptsTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  sent: z.boolean().optional(),
  sent_at: z.string().optional().nullable(),
  updated_at: z.string().optional(),
});

export const rowVehicleTypesTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  type_name: z.string(),
  updated_at: z.string(),
});

export const insertVehicleTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  type_name: z.string(),
  updated_at: z.string().optional(),
});

export const updateVehicleTypesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  type_name: z.string().optional(),
  updated_at: z.string().optional(),
});

export const rowVehiclesTypeSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  plate: z.string(),
  status: publicVehicleStatusEnumSchema,
  updated_at: z.string(),
  vehicle_type_id: z.string(),
});

export const insertVehiclesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string(),
  plate: z.string(),
  status: publicVehicleStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
  vehicle_type_id: z.string(),
});

export const updateVehiclesTypeSchema = z.object({
  created_at: z.string().optional(),
  id: z.string().optional(),
  name: z.string().optional(),
  plate: z.string().optional(),
  status: publicVehicleStatusEnumSchema.optional(),
  updated_at: z.string().optional(),
  vehicle_type_id: z.string().optional(),
});

export const relationshipsVehiclesTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("fk_vehicle_type"),
    columns: z.tuple([z.literal("vehicle_type_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("vehicle_types"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCalendarEventsTypeSchema = z.object({
  campus_ids: z.array(z.string()).nullable(),
  enrolment_ids: z.array(z.string()).nullable(),
  enrolments_events: jsonSchema.nullable(),
  events_activities: jsonSchema.nullable(),
  id: z.string().nullable(),
  instructor_ids: z.array(z.string()).nullable(),
  is_published: z.boolean().nullable(),
  lesson: jsonSchema.nullable(),
  lesson_id: z.string().nullable(),
  location: jsonSchema.nullable(),
  location_id: z.string().nullable(),
  scheduled_at: z.string().nullable(),
  staff_events: jsonSchema.nullable(),
  status: publicEventStatusEnumSchema.nullable(),
});

export const relationshipsCalendarEventsTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_location_id_fkey"),
    columns: z.tuple([z.literal("location_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("locations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCalendarEventsMvTypeSchema = z.object({
  campus_ids: z.array(z.string()).nullable(),
  enrolment_ids: z.array(z.string()).nullable(),
  enrolments_events: jsonSchema.nullable(),
  events_activities: jsonSchema.nullable(),
  id: z.string().nullable(),
  instructor_ids: z.array(z.string()).nullable(),
  is_published: z.boolean().nullable(),
  lesson: jsonSchema.nullable(),
  lesson_id: z.string().nullable(),
  location: jsonSchema.nullable(),
  location_id: z.string().nullable(),
  scheduled_at: z.string().nullable(),
  staff_events: jsonSchema.nullable(),
  status: publicEventStatusEnumSchema.nullable(),
});

export const relationshipsCalendarEventsMvTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_location_id_fkey"),
    columns: z.tuple([z.literal("location_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("locations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const rowCalendarEventsRawTypeSchema = z.object({
  campus_ids: z.array(z.string()).nullable(),
  enrolment_ids: z.array(z.string()).nullable(),
  enrolments_events: jsonSchema.nullable(),
  events_activities: jsonSchema.nullable(),
  id: z.string().nullable(),
  instructor_ids: z.array(z.string()).nullable(),
  is_published: z.boolean().nullable(),
  lesson: jsonSchema.nullable(),
  lesson_id: z.string().nullable(),
  location: jsonSchema.nullable(),
  location_id: z.string().nullable(),
  scheduled_at: z.string().nullable(),
  staff_events: jsonSchema.nullable(),
  status: publicEventStatusEnumSchema.nullable(),
});

export const relationshipsCalendarEventsRawTypeSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal("events_lesson_id_fkey"),
    columns: z.tuple([z.literal("lesson_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("lessons"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
  z.object({
    foreignKeyName: z.literal("events_location_id_fkey"),
    columns: z.tuple([z.literal("location_id")]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal("locations"),
    referencedColumns: z.tuple([z.literal("id")]),
  }),
]);

export const publicAssertCanDeleteInvoiceArgsSchema = z.never();

export const publicAssertCanDeleteInvoiceReturnsSchema = z.boolean();

export const publicCalendarMvWindowEndArgsSchema = z.never();

export const publicCalendarMvWindowEndReturnsSchema = z.string();

export const publicCalendarMvWindowStartArgsSchema = z.never();

export const publicCalendarMvWindowStartReturnsSchema = z.string();

export const publicCanAccessEventArgsSchema = z.object({
  event_id: z.string(),
});

export const publicCanAccessEventReturnsSchema = z.boolean();

export const publicCheckAndQueueCalendarRefreshArgsSchema = z.never();

export const publicCheckAndQueueCalendarRefreshReturnsSchema = z.undefined();

export const publicDeduplicateTextArrayArgsSchema = z.object({
  input: z.array(z.string()),
});

export const publicDeduplicateTextArrayReturnsSchema = z.array(z.string());

export const publicGetVaultSecretArgsSchema = z.object({
  secret_name: z.string(),
});

export const publicGetVaultSecretReturnsSchema = z.string();

export const publicHasStaffRoleArgsSchema = z.object({
  roles: z.array(publicStaffRoleEnumSchema),
});

export const publicHasStaffRoleReturnsSchema = z.boolean();

export const publicProofOfFundingDocumentTypeIdArgsSchema = z.never();

export const publicProofOfFundingDocumentTypeIdReturnsSchema = z.string();

export const publicRecomputeInvoiceStatusArgsSchema = z.object({
  p_include_cancelled: z.boolean().optional(),
  p_invoice_id: z.string(),
});

export const publicRecomputeInvoiceStatusReturnsSchema =
  publicInvoiceStatusEnumSchema;

export const publicRecomputeOverdueInvoicesArgsSchema = z.never();

export const publicRecomputeOverdueInvoicesReturnsSchema = z.number();

export const publicRestoreInvoiceArgsSchema = z.object({
  p_invoice_id: z.string(),
});

export const publicRestoreInvoiceReturnsSchema = publicInvoiceStatusEnumSchema;

export const publicStaffHasCampusArgsSchema = z.object({
  campus_ids: z.array(z.string()),
});

export const publicStaffHasCampusReturnsSchema = z.boolean();

export const publicSyncEnrolmentProofOfFundingArgsSchema = z.object({
  p_enrolment_id: z.string(),
});

export const publicSyncEnrolmentProofOfFundingReturnsSchema = z.undefined();

export const publicUpsertInvoiceWithChildrenArgsSchema = z.object({
  p_due_date: z.string(),
  p_enrolment_id: z.string().optional(),
  p_invoice_date: z.string().optional(),
  p_invoice_id: z.string().optional(),
  p_items: jsonSchema,
  p_payer_id: z.string(),
  p_payment_schedule: jsonSchema,
  p_total: z.number(),
});

export const publicUpsertInvoiceWithChildrenReturnsSchema = z.string();
